import {db,} from "../db";
import {
    signin,
    getTokens,
    getAccountFromGoogle,
    updateAccount,
    updateAliasAccount,
    registerHostingService,
    getCollectionHashes,
    getCollectionImage,
    updateOpenAIKey,
    getUndeliveredImages,
    getWhmcsData
} from "../api-helper";
import CloseIcon from "../images/icons/white-close.svg";
import {useEffect, useState} from "react";
import { useAccountContext, useAccountContextDispatch } from "../context/AccountContext";
import TokenIcon from '../images/icons/promptus-token.svg';
import PasswordHidden from '../images/icons/input-bar-icons/icon-input-bar-password-hidden.svg';
import PasswordShown from '../images/icons/input-bar-icons/icon-input-bar-password-shown.svg';
import Swal from "sweetalert2";
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
import { isUndefined } from "cropperjs";
import { useCollectionContextDispatch } from "../context/CollectionContext";
import hostingLogo from '../images/mb_logo.png';
import axios from "axios";

export default function Profile() {
    const [loading, setLoading] = useState(false);
    const [logloading, setLogloading] = useState(false);
    const [logoutloading, setLogoutloading] = useState(false);
    const [accountNo, setAccountNo] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [newUsername, setNewUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passSecret, setPassSecret] = useState("")
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [account, setAccount] = useState({});
    const [loggedIn, setLoggedIn] = useState(false);
    const [showChangeUser, setShowChangeUser] = useState(false);
    const [showHostRegister, setShowHostRegister] = useState(false);
    const [showOpenAISettings, setShowOpenAISettings] = useState(false);
    const [error, setError] = useState("");
    const [changeError, setChangeError] = useState("");
    const [method, setMethod] = useState(false);
    const [managerOpen, setManagerOpen] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [imageMetadata, setImageMetadata] = useState([]);
    const accountContextDispatch = useAccountContextDispatch();
    const accountContext = useAccountContext()
    const collectionContextDispatch = useCollectionContextDispatch();

    //INPUTS FOR HOSTING SERVICE
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [addressOne, setAddressOne] = useState('');
    const [cityName, setCityName] = useState('');
    const [country, setCountry] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const [hostingCreated, setHostingCreated] = useState('');
    const [hostingDomain, setHostingDomain] = useState('');
    const [hostingStatus, setHostingStatus] = useState('');
    const [hostingSetupInvoice, setHostingSetupInvoice] = useState('');
    const [hostingSetupInvoiceStatus, setHostingSetupInvoiceStatus] = useState('');
    const [hostingSetupInvoiceAmount, setHostingSetupInvoiceAmount] = useState('');
    const [hostingOrderNumber, setHostingOrderNumber] = useState('');

    const [openAIKey, setOpenAIKey] = useState('');
    const [openAIKeyError, setOpenAIKeyError] = useState("");
    const [showHostingDetails, setShowHostingDetails] = useState(false);

    const getSettings = async () => {
        setLoading(true);
        setAccountNo(accountContext.accountDetails.accountNo)
        setAccount(accountContext.accountDetails)
        setLoggedIn(accountContext.loggedIn)
    }

    const fetchWHMCSData = () => {
        getWhmcsData(accountContext.accountDetails.accountNo).then(async(data) => {
            console.log("WhmcsData: ", data)
            setShowHostingDetails(false)
            if (data.whmcsOrderId > 0) {
                setShowHostingDetails(true)
                setHostingCreated(data.dateCreated);
                setHostingDomain(data.domain);
                setHostingStatus(data.whmcsOrderStatus);
                setHostingSetupInvoice(data.whmcsInvoiceId);
                setHostingSetupInvoiceStatus(data.whmcsPaymentStatus);
                setHostingSetupInvoiceAmount(data.whmcsInitialAmount);
                setHostingOrderNumber(data.whmcsOrderNumber)

            }
        });
    }

    useEffect(() => {
        getSettings().then(() => setLoading(false));
        if (accountContext.loggedIn === true) {
            setAccount(accountContext.accountDetails)
            setOpenAIKey(accountContext.accountDetails.openaiKey || '');
            setNewUsername(accountContext.accountDetails.alias)
            fetchWHMCSData()
        }
    }, []);


    // useEffect(() => {
    //     db.account.where("key").equals("accountDetails").first(setting => {
    //         console.log("Updating account details");
    //         accountNosignin(setting.value.accountNo)
    //         .then((account) => {
    //             db.collectedImages.clear();
    //             db.collectedImages.bulkAdd(JSON.parse(account.images));
    //             console.log("Updated account details");
    //             accountContextDispatch({type: 'login', signin: account, passSecret: JSON.parse(localStorage.getItem("password"))})
    //             accountContextDispatch({type: 'tokens', tokens: account.tokens})
    //         })
    //     })
    // },[])

    /**
     * Get the login method
     * @returns {Promise<*>}
     */
    const getMethod = async () => {
        if (!method) {
            return signin(emailAddress, password)
        } else {
            return getAccountFromGoogle(emailAddress)
        }
    }

    const login = () => {
        setLogloading(true);
        getMethod()
        .then(async(data) => {
            if (data.message) {
                setError(data.message)
                setLogloading(false)
            } else{
                setChangeError("");
                setError("");
                setEmailAddress("");
                accountContextDispatch({type: 'login', signin: data.account, passSecret: password})
                localStorage.setItem("password", JSON.stringify(password))
                setPassword("");
                setAccount(data.account);
                //setOpenAIKey(data.account.openaiKey)
                setNewUsername(data.account.alias)
                let openAIKey = data.account.openaiKey || "";
                setOpenAIKey(openAIKey)
                setAccountNo(data.account.accountNo)
                setLoggedIn(true);
                localStorage.setItem("account", JSON.stringify(data.account))
                db.account.put({key: 'accountDetails', value: data.account})
                try {
                    getTokens(data.account.accountNo).then(data => {
                        accountContextDispatch({type : "tokens", tokens: data.credits})
                        setLogloading(false);
                    })
                } catch (error) {
                    console.error("Error fetching tokens during login: ", error);
                    accountContextDispatch({type : "tokens", tokens: 0})                  
                }

                fetchWHMCSData()

                const hashes = await getCollectionHashes(data.account.accountNo);
                console.log(hashes);
                if (!sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "false") {
                    sessionStorage.setItem('initialCollectionLoad', 'true');
                    // Use map to create an array of promises
                    const imagePromises = hashes.map((hash, index) => {
                        return getCollectionImage(data.account.accountNo, hash.hash)
                            .then(image => {
                                // Create an object that includes both the image and its original index
                                return { image, index };
                            });
                    });

                    // Wait for all promises to resolve
                    Promise.all(imagePromises).then(images => {
                        images.forEach(({ image, index }) => {
                            // Now you can use the index if needed to maintain original order
                            db.collectedImages.put({uid: image.uid, imageID: index + 1, image: image.image, seed: image.seed, model: image.model, hash: image.hash, online: image.online, tag: image.tag, prompt: image.prompt, public: image.public});
                            console.log("Loaded image from the server: ", image.imageID, image.hash);
                        });
                        console.log("Finished loading images from the server");
                        collectionContextDispatch({type: 'finishedLoading'});
                    }).catch(error => {
                        console.error("An error occurred while loading images: ", error);
                    }).finally(() => {
                        setLogloading(false);
                    });
                }
            }


        })
    }

    const logout = async () => {
        setLogoutloading(true)
        accountContextDispatch({type: "logout"})
        localStorage.removeItem("account")
        db.account.where("key").equals("accountDetails").delete()
        setAccountNo("");
        db.collectedImages.clear();
        setLoggedIn(false);
        setLogoutloading(false);
        sessionStorage.setItem('initialCollectionLoad', 'false');
        sessionStorage.setItem('finishedCollectionLoad', 'false');
        collectionContextDispatch({type: 'resetLoading'});
        setShowHostingDetails(false)
    }

    const changeOpenAPIKey = () => {
        //if (openAIKey === "") {
        //    setOpenAIKeyError("Please provide the OpenAI Key")
        //} else {
        updateOpenAIKey(openAIKey, accountContext.accountDetails.accountNo).then(async data => {
            try {
                if (openAIKey === data.account.openaiKey) {
                    setAccount(data.account);
                    setOpenAIKey(openAIKey);

                    const updated = await db.account.update("accountDetails", { value: data.account });

                    if (updated) {
                        console.log(`OpenAI Key for account ${accountContext.accountDetails.accountNo} updated successfully.`);
                        accountContext.accountDetails.openaiKey = openAIKey;

                        // Show success message
                        Swal.fire({
                            title: "Success",
                            text: "Your OpenAI Key was successfully changed",
                            icon: "success",
                            timer: 1200,
                            showConfirmButton: false
                        });
                    }
                }
            } catch (error) {
                console.error('Error occurred:', error);
            }
        });

        //}
    }

    const changeUsername = () => {

        //if (account.alias.toLowerCase() == newUsername.toLocaleLowerCase()) {
        // ** CONTROLLED BY THE API SO USERNAME EXISTS DOESN'T OCCUR WHEN SAVING CURRENT USERNAME
        //    setChangeError("Community alias already exists");
        //} else {
            if (newUsername == "") {
                setChangeError("Please add an alias");
            } else if (newUsername.includes("_")) {
                setChangeError("The _ character is not allowed in your alias");
            } else if (newUsername.startsWith("-") || newUsername.endsWith("-")) {
                setChangeError("The - characters is not allowed at the beginning/end of your alias");
            } else if (/[A-Z]/.test(newUsername)) {
                setChangeError("Uppercase letters are not allowed");
            } else {
                setLogloading(true);
                updateAliasAccount(newUsername, accountNo)
                .then((data) => {
                    console.log(data)
                    let updateError = false;
                    setChangeError("");
                    if (data.message != "") {
                        updateError = true;
                        setChangeError(data.message);
                    }
                    accountContextDispatch({type: 'login', signin: data.account, passSecret: JSON.parse(localStorage.getItem("password"))})
                    setAccount(data.account);
                    localStorage.setItem("account", JSON.stringify(data.account))
                    db.account.put({key: 'accountDetails', value: data.account})
                    db.collectedImages.bulkAdd(JSON.parse(data.account.images))
                    setAccountNo(data.account.accountNo)
                    if (!updateError) {
                        setNewUsername(data.account.alias);
                    } else {
                        setNewUsername(newUsername);
                    }
                    setLoggedIn(true);
                    try {
                        getTokens(data.account.accountNo)
                        .then(data => {
                            accountContextDispatch({type : "tokens", tokens: data.tokens})
                            setLogloading(false);
                            if (!updateError) {
                                Swal.fire({
                                    title: "Success",
                                    text: "Your alias was successfully changed",
                                    icon: "success",
                                    timer: 1200,
                                    showConfirmButton: false
                                })
                            }
                        })                    
                    } catch (error) {
                        console.error("Error updating tokens on username change: ", error);
                        accountContextDispatch({type : "tokens", tokens: 0})
                           
                    }
                })
            }
        //}
    }

    const handleOpenManager = () => {
        window.location.replace(`promptus-pm:/accountNo=${account.accountNo}`)
    }

    const handleKeyDownEmail = (e) => {
        if (e.key === "Enter" || e.keyCode == 13) {
            login()
        }
    };

    const handleKeyDownGmail = (e) => {
        if (e.key === "Enter" || e.keyCode == 13) {
            login()
        }
      };

    const registerService = () => {
        console.log("Registering");
        registerHostingService(accountNo,account.emailAddress,account.alias)
    }

    const tester = async () => {
        console.log("Testing");

        // const prompt = {message: "DUMDUM"}

        // try {
        //     const response = await axios.post(`http://localhost:5000/api/generate`, prompt, {
        //         headers: {
        //             "Content-Type": "application/json",
        //             "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
        //         }
        //     });
        //     console.log(response);
            
        // } catch (error) {
        //     console.error("Error generating prompt:", error);
        //     // generateStatusDispatch({ type: 'error', message: 'An unexpected error occurred' });
        // }
        // const checkImages = async () => {
        //     const allImages = await db.images.toArray();
        //     const totalImages = allImages.length;
        //     const batchSize = 100; // Process images in batches to avoid resource issues
            
        //     for (let i = 0; i < totalImages; i += batchSize) {
        //         const batch = allImages.slice(i, i + batchSize);
                
        //         for (let imageRecord of batch) {
        //             try {
        //                 console.log("Processing Image Record: ", imageRecord.id);
        //                 let imageData = imageRecord.image;
       
        //                 // Skip images with empty imageData
        //                 if (!imageData || imageData === "") {
        //                     console.log("Skipping empty image:", imageRecord.id);
        //                     continue;
        //                 }
       
        //                 // Construct a complete data URL
        //                 const dataUrl = `data:image/png;base64,${imageData}`;
       
        //                 // Proceed to check if the image can be loaded/rendered
        //                 await new Promise((resolve, reject) => {
        //                     const img = new Image();
        //                     img.onload = () => {
        //                         console.log('Image loaded successfully:', imageRecord.id);
        //                         resolve();
        //                     };
        //                     img.onerror = () => {
        //                         console.error('Corrupted image detected:', imageRecord.id);
        //                         resolve();
        //                     };
        //                     img.src = dataUrl;
        //                 });
        //             } catch (e) {
        //                 console.error('Error processing image:', imageRecord.id, e);
        //             }
        //         }
                
        //         // Add a small delay between batches to prevent blocking the main thread
        //         await new Promise(resolve => setTimeout(resolve, 100));
        //     }
        // };
    
        // checkImages();
    }

    useEffect(() => {
        getWhmcsData(accountContext.accountDetails.accountNo).then(async(data) => {
            console.log("WhmcsData: ", data)

            if (data.whmcsOrderId > 0) {
                setShowHostingDetails(true)
                setHostingCreated(data.dateCreated);
                setHostingDomain(data.domain);
                setHostingStatus(data.whmcsOrderStatus);
                setHostingSetupInvoice(data.whmcsInvoiceId);
                setHostingSetupInvoiceStatus(data.whmcsPaymentStatus);
                setHostingSetupInvoiceAmount(data.whmcsInitialAmount);
                setHostingOrderNumber(data.whmcsOrderNumber)

            }
        });
    }, [accountContext.accountDetails.accountNo]);


    return (
        <div className={"px-4 relative container mx-auto"}>
            <h2 className={"text-xl py-2 font-bold flex flex-row items-center"}>
                <span>Profile</span>
                <hr className={"ml-2 flex-grow border border-white/40 bg-white/40"} />
            </h2>
            <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-full md:max-w-screen-md mx-auto"}>
                {loading ? <div className={"font-bold"}>Loading stored settings.</div> : null}
                <div className={"text-lg p-5 text-center"}>
                    Account Number: {accountContext.accountDetails.accountNo}
                </div>
                {/* <button onClick={tester}>Test</button> */}
                {accountContext.loggedIn ?
                    <a onClick={handleOpenManager}
                    className="rounded w-1/2 mx-auto mt-1 mb-3 p-2 bg-yellow text-center text-dark-blue shadow font-bold cursor-pointer">Open Manager</a>
                 : null}
                 <hr className={"mt-5 flex-grow border border-white/40 bg-white/40"}/>
                {!accountContext.loggedIn ? 
                    // NOT SIGNED IN
                    <>
                        <h3 className="text-lg font-bold py-10 pb-5">Log In</h3>
                        {!method ?
                            <>
                                <p className="text-right pb-5 text-yellow font-semibold" onClick={() => {
                                    setMethod(!method)
                                    setEmailAddress("")
                                    setPassword("")
                                }}>Sign in with google email</p>
                                <div className="flex flex-col">
                                    <div className={"py-2 pt-0"}>
                                        <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">Email Address</label>
                                        <input type="text" name="emailAddress" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)}
                                            className="w-full rounded-lg text-dark-blue border-0 p-2"
                                            placeholder="Email Address"/>
                                    </div>
                                    <div className={"py-2 pt-0 relative"}>
                                        <label className="block mb-2 text-sm font-medium" htmlFor="password">Password</label>
                                        <input type={passwordVisibility ? "text" : "password"} name="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyDownEmail}
                                            className="w-full rounded-lg text-dark-blue border-0 p-2"
                                            placeholder="Password"/>
                                        <button className="w-9 absolute text-dark-blue right-4 top-8" onClick={() => setPasswordVisibility(!passwordVisibility)}><img src={passwordVisibility ? PasswordShown : PasswordHidden}/> </button>    
                                    </div>
                                    <div className="flex flex-row justify-between">
                                        <a href="https://signup.promptus.ai/forgot-password" target="blank" className="font-semibold mt-2">Forgot your password?</a>
                                        <a href="https://signup.promptus.ai/" target="blank" className="font-semibold mt-2">Don't have an account? Register here</a>
                                    </div>
                                    {error ? <div className="w-3/4 mx-auto my-3 p-2 bg-white/50 text-center text-red-600 font-semibold">
                                        {error}
                                    </div> : null }
                                    <button onClick={login} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                        {logloading ?
                                            <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                            </svg>
                                        :
                                            null
                                        }
                                        Log In
                                    </button>
                                </div>
                            </>
                            :
                            <>
                                <p className="text-right pb-5 text-yellow font-semibold" onClick={() => {
                                    setMethod(!method)
                                    setEmailAddress("")
                                    setPassword("")
                                }}>Sign in with email</p>
                                <div className="flex flex-col">
                                    <div className={"py-2 pt-0"}>
                                        <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">Email Address</label>
                                        <input type="text" name="emailAddress" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} onKeyDown={handleKeyDownGmail}
                                            className="w-full rounded-lg text-dark-blue border-0 p-2"
                                            placeholder="Email Address"/>
                                    </div>
                                    <a href="https://signup.promptus.ai/" target="blank" className="font-semibold mt-2 text-right">Don't have an account? Register here</a>
                                    {error ? <div className="w-3/4 mx-auto my-3 p-2 bg-white/50 text-center text-red-600 font-semibold">
                                        {error}
                                    </div> : null }
                                    <button onClick={login} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                    {logloading ?
                                        <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                        </svg>
                                    :
                                        null
                                    }
                                        Log In
                                    </button>
                                </div>
                            </>
                        }
                    </>    
                    : 
                    // WHEN SIGNED IN
                    <>
                        <h3 className="text-lg font-bold py-10">Account Details</h3>
                        <div className="bg-dark-blue/30 p-5 rounded-lg">
                            <div className="flex flex-row justify-between">
                                <div>
                                    <h1 className="text-2xl capitalize text-yellow font-bold">{accountContext.accountDetails.alias}</h1>
                                    <h1>{accountContext.accountDetails.emailAddress}</h1>
                                </div>
                                <div>
                                    <h1 className="text-lg font-semibold"><img src={TokenIcon} alt="Token Icon" className="ms-1 mb-1" />{accountContext.tokens}</h1>   
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2">
                            <a href={`https://${accountContext.accountDetails.alias}.promptus.ai`} target="blank" className="rounded w-2/3 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold text-center">View Public Gallery</a>
                            <button onClick={logout} className="rounded w-2/3 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                            {logoutloading ?
                                <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                </svg>
                            :
                                null
                            }
                                Log Out
                            </button>
                        </div>


                    </>
                }
                </div>

                {accountContext.loggedIn ?
                    <>
                        <div
                            className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-full md:max-w-screen-md mx-auto mt-10"}>
                            <>
                                {!showChangeUser ?
                                    <h3 className="text-lg font-bold py-1 text-center"
                                        onClick={() => setShowChangeUser(true)}>Change/Create Username?</h3>
                                    :
                                    <>  
                                        <div className="flex flex-row justify-between">
                                            <h3 className="text-lg font-bold py-1">Change/Create Username</h3>
                                            <button onClick={() => setShowChangeUser(false)}>
                                                <img src={CloseIcon} alt='Close Image' className='h-7'/>
                                            </button>
                                        </div>
                                        <div className={"bg-dark-blue/30 p-4 pb-6 rounded-lg mt-5"}>
                                            <label className="block mb-2 text-sm font-medium" htmlFor="usernameChange">
                                                Username</label>
                                            <input type="text" name="usernameChange" value={newUsername}
                                                   onChange={(e) => setNewUsername(e.target.value)}
                                                   className="w-full rounded-lg text-dark-blue border-0 p-2"
                                                   placeholder="Change/Create Username"/>
                                        </div>
                                        {changeError ? <div
                                            className="w-3/4 mx-auto my-3 p-2 bg-white/50 text-center text-red-600 font-semibold">
                                            {changeError}
                                        </div> : null}
                                        <div className="flex">
                                            <button
                                                className="rounded w-1/3 mx-auto mt-6 p-2 bg-yellow text-dark-blue shadow font-bold"
                                                onClick={changeUsername}>Confirm
                                            </button>
                                        </div>
                                    </>
                                }
                            </>
                        </div>
                        <div
                            className={`bg-dark-blue/30 rounded-lg flex flex-col p-5 w-full md:max-w-screen-md mx-auto mt-10`}>
                            <>
                                {!showHostRegister ? (
                                    <h3
                                        className="text-lg font-bold py-1 text-center"
                                        onClick={() => setShowHostRegister(true)}
                                    >
                                        Hosting Details
                                    </h3>
                                ) : showHostingDetails ? (
                                    <>
                                        <div className="flex flex-row justify-between">
                                            <h3 className="text-lg font-bold py-1">Hosting Details</h3>
                                            <button onClick={() => setShowHostRegister(false)}>
                                                <img src={CloseIcon} alt='Close Image' className='h-7'/>
                                            </button>
                                        </div>
                                        <div className="grid grid-cols-2">
                                            <div>
                                                <label className="block pt-6 pb-2 font-bold"
                                                       htmlFor="hostEmail">Created: </label>
                                                <div className="flex flex-col md:flex-row gap-2 place-items-center">
                                                    {hostingCreated}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block pt-6 pb-2 font-bold"
                                                       htmlFor="hostEmail">Order Number: </label>
                                                <div className="flex flex-col md:flex-row gap-2 place-items-center">
                                                    {hostingOrderNumber}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block pt-6 pb-2 font-bold"
                                                       htmlFor="hostEmail">Domain: </label>
                                                <div className="flex flex-col md:flex-row gap-2 place-items-center">
                                                    {hostingDomain}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block pt-6 pb-2 font-bold"
                                                       htmlFor="hostEmail">Status: </label>
                                                <div className="flex flex-col md:flex-row gap-2 place-items-center">
                                                    {hostingStatus}
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block pt-6 pb-2 font-bold"
                                                       htmlFor="hostEmail">Initial Setup Invoice (Status): </label>
                                                <div className="flex flex-col md:flex-row gap-2 place-items-center">
                                                    {hostingSetupInvoice} ({hostingSetupInvoiceStatus})
                                                </div>
                                            </div>
                                            <div>
                                                <label className="block pt-6 pb-2 font-bold"
                                                       htmlFor="hostEmail">Initial Setup Invoice Amount: </label>
                                                <div className="flex flex-col md:flex-row gap-2 place-items-center">
                                                    {process.env.REACT_APP_WHMCS_CURRENCY} {hostingSetupInvoiceAmount}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex">
                                            <a
                                                className="rounded w-1/3 mx-auto mt-6 p-2 bg-yellow text-dark-blue shadow font-bold text-center"
                                                href={`https://${process.env.REACT_APP_WHMCS_URL}/clientarea.php?action=invoices`}
                                                target="hosting"
                                                rel="noopener noreferrer"
                                            >Go to Hosting Services</a>
                                        </div>
                                        <br></br>
                                        <div className="w-full">
                                            <div
                                                className="justify-self-center text-center flex justify-center items-center">
                                                <div
                                                    className="col-span-2 text-center flex justify-center items-center">
                                                    <span>Powered by</span>
                                                    <a href="https://www.mailbox.net.uk/">
                                                        <img className="inline-block"
                                                           src={hostingLogo}
                                                           alt="Mailbox Internet Logo"
                                                           title="Powered by Mailbox Internet"/>
                                                    </a>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="flex flex-row justify-between">
                                            <h3 className="text-lg font-bold py-1">Register for Hosting Services</h3>
                                            <button onClick={() => setShowHostRegister(false)}>
                                                <img src={CloseIcon} alt='Close Image' className='h-7'/>
                                            </button>
                                        </div>
                                        <div className="flex">
                                            <a
                                                className="rounded w-1/3 mx-auto mt-6 p-2 bg-yellow text-dark-blue shadow font-bold text-center"
                                                href={`https://signup.promptus.ai/account#`}
                                                    target="promptus"
                                                    rel="noopener noreferrer"
                                                >
                                                    Click here to register!
                                                </a>
                                            </div>
                                        </>
                                        )}

                                    </>
                                    </div>
                                    <div
                            className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-full md:max-w-screen-md mx-auto mt-10"}>
                            <>
                                {!showOpenAISettings ?
                                    <h3 className="text-lg font-bold py-1 text-center"
                                        onClick={() => setShowOpenAISettings(true)}>OpenAI Settings</h3>
                                    :
                                    <>
                                        <div className="flex flex-row justify-between">
                                            <h3 className="text-lg font-bold py-1">OpenAI Key</h3>
                                            <button onClick={() => setShowOpenAISettings(false)}>
                                                <img src={CloseIcon} alt='Close Image' className='h-7'/>
                                            </button>
                                        </div>
                                        <div className={"bg-dark-blue/30 p-4 pb-6 rounded-lg mt-5"}>
                                            <label className="block mb-2 text-sm font-medium" htmlFor="openAIKey">OpenAI Key</label>
                                            <input type="text" name="openAIKey" value={openAIKey}
                                                   onChange={(e) => setOpenAIKey(e.target.value)}
                                                   className="w-full rounded-lg text-dark-blue border-0 p-2"
                                                   placeholder="Enter your OpenAI Key"/>
                                        </div>
                                        {openAIKeyError ? <div
                                            className="w-3/4 mx-auto my-3 p-2 bg-white/50 text-center text-red-600 font-semibold">
                                            {openAIKeyError}
                                        </div> : null}
                                        <div className="flex">
                                            <button
                                                className="rounded w-1/3 mx-auto mt-6 p-2 bg-yellow text-dark-blue shadow font-bold"
                                                onClick={changeOpenAPIKey}>Confirm
                                            </button>
                                        </div>
                                    </>
                                }
                            </>
                        </div>
                    </>
                    :
                    null
                }
        </div>
    );
}
